import * as Sentry from "@sentry/react";
import type { UserProfile } from "@speakai/common/src/auth/types";
import { accountTags, applyAccountTags } from "@speakai/common/src/observability/sentry-tags";

/** Sets the Sentry user (id, email, full name, auto IP) and the plan, subscription and company tags from the profile. */
export function setSentryUserContext(profile: UserProfile): void {
  Sentry.setUser({
    id: profile._id,
    email: profile.email,
    username: [profile.firstName, profile.lastName].filter(Boolean).join(" ") || undefined,
    ip_address: "{{auto}}",
  });
  Sentry.setContext("subscription", { plan: profile.subscription?.planId, status: accountTags(profile).subscription_status });
  applyAccountTags(Sentry.setTag, profile);
}

/** Clears the Sentry user, subscription context and the plan, subscription and company tags at sign-out. */
export function clearSentryUserContext(): void {
  Sentry.setUser(null);
  Sentry.setContext("subscription", null);
  applyAccountTags(Sentry.setTag, null);
}
